import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { JOURNAL_ENTRY } from "./apiRoutes";

const mutateAddPostJournalEntry = async ({
  documentId,
}: {
  documentId: string;
}) => {
  return await axiosAuth.post(`${JOURNAL_ENTRY}/${documentId}/post`);
};

const useAddPostJournalEntryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      documentId: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddPostJournalEntry,
    ...queryParams,
  });

export default useAddPostJournalEntryMutation;
